export default __webpack_public_path__ + "static/media/Great Western.01407b1c.svg";